import BlogPostV2 from 'components/BlogV2/BlogPostV2'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'
import { getBlogEntryById } from 'pages/api/contentful'

const BlogPostPage = ({ locale, data, relatedBlogs }) => {
  const router = useRouter()

  return (
    <>
      <BlogPostV2 data={data} locale={locale} relatedBlogs={relatedBlogs} />
    </>
  )
}

import { getAllBlogData } from 'pages/api/contentful'

export const getServerSideProps = async ({ params, locale }) => {
  // Fetch the current blog post
  const data = await getBlogEntryById(params.slug[0])

  // Fetch all blog posts for related articles
  const allBlogs = await getAllBlogData()

  const filteredBlogs = allBlogs.items
    .filter(
      (item) => item.sys.id !== data.sys.id && item.fields.locale === locale,
    )
    .slice(0, 3) // Limit to 3 related blog posts
  return {
    props: {
      data,
      relatedBlogs: filteredBlogs, // Pass related blogs to the component
      ...(await serverSideTranslations(locale, ['blog', 'nav', 'offer'])),
      locale,
    },
  }
}

export default BlogPostPage
